// CONTINUING A CUT OFF REPLY (cut off fix (d), 11/10/2026). The officer's
// regenerate report continued a reply cut off at its limit by sending the partial
// output back as an assistant prefill. The current models reject a prefill (the
// request fails), so the continuation never ran: every report over the larger
// retry was salvaged and saved provisional. Now the partial output goes back as
// an ordinary assistant turn followed by a user turn asking for the rest, which
// the models accept, and the two parts are joined with any repeated overlap
// removed. A joined reply that still does not read as whole JSON stays
// provisional (the caller checks with readsWhole).

export const CONTINUE_INSTRUCTION = 'Your previous reply was cut off at the length limit. Continue it from the exact character where it stopped. Output only the remaining text: do not repeat anything already written, and add no preamble, explanation or code fences.';

/** The messages for one continuation: the conversation, the partial reply, the request. */
export function continuationMessages(messages, partial) {
  return [...(messages || []), { role: 'assistant', content: String(partial || '').replace(/\s+$/, '') }, { role: 'user', content: CONTINUE_INSTRUCTION }];
}

/** Joins a continuation onto the partial reply: fences dropped, a repeated overlap removed, a restart replaces. */
export function stitchContinuation(text, more) {
  const base = String(text || '').replace(/\s+$/, '');
  let cont = String(more || '').replace(/^\s*```(?:json)?\s*\n?/i, '').replace(/\n?\s*```\s*$/, '');
  if (!cont.trim()) return base;
  // The model started the whole reply again: keep the new one only if it is whole.
  if (/^\s*\{/.test(cont) && /^\s*\{/.test(base) && readsWhole(cont)) return cont.trim();
  const max = Math.min(400, base.length, cont.length);
  for (let k = max; k >= 8; k--) if (base.endsWith(cont.slice(0, k))) return base + cont.slice(k);
  // A continuation inside a string or between tokens: the leading space is the model's own.
  return base + cont.replace(/^\n+/, '');
}

/** The reply as one JSON object read without repair, or null. */
export function parseWhole(text) {
  const t = String(text || '').replace(/```json|```/g, '').trim();
  const a = t.indexOf('{'), b = t.lastIndexOf('}');
  if (a === -1 || b <= a) return null;
  try { const o = JSON.parse(t.slice(a, b + 1)); return (o && typeof o === 'object' && !Array.isArray(o)) ? o : null; } catch (_) { return null; }
}

/** True when the reply reads as one JSON object without repair. */
export function readsWhole(text) { return parseWhole(text) !== null; }
